var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row roomy align-center align-stretch" },
    _vm._l(_vm.filteredSkus, function (sku, index) {
      return _c(
        "div",
        { key: sku, staticClass: "column-12 laptop:column-4" },
        [
          !_vm.isLoading
            ? _c("plan-summary-card", {
                attrs: {
                  "current-subscription": _vm.currentSubscription,
                  "is-last": _vm.filteredSkus.length === index + 1,
                  "modal-context-slug": _vm.upsellTriggerSlug,
                  plan: _vm.getPlan(sku),
                  "plan-color": _vm.planColor(sku),
                  "is-in-modal-context": "",
                  "plan-icon-style": _vm.getPlanIconStyle(sku),
                  "subscription-discounts": _vm.subscriptionDiscounts,
                  "on-sale": _vm.onSale(sku),
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }